var dividedAsset = require("./dividedAsset");

//split assets by multiple property fields
/*
		{style: styles.styleDef,
			id: 'dekl',
			fullSource: false,
			groups: [
				{key:'lvl10', field: 'APDZ_VIETA', style: style.styleDef(optional)},
				{key:'lvl8', field: 'Funkcional1', style: style.styleDef(optional)},
			]
		}
 */
var dividedAssetManger = function(optionsIn) {

	this.fullSource = optionsIn.fullSource;
	this.defaultStyle = null;
	this.activeGroup = null;
	this.noneGroup = 'MIN'; // NONE / GRPUP / MIN / 23
	this.visible = false;

	if(typeof optionsIn.noneGroup !== 'undefined') {

		this.noneGroup = optionsIn.noneGroup;
	}
	if(typeof optionsIn.style !== 'undefined') {

		this.defaultStyle = optionsIn.style;
	}
	if(typeof optionsIn.visible !== 'undefined') {

		this.visible = optionsIn.visible;
	}

	this.dividedAssets = [];

	for (var i = optionsIn.groups.length - 1; i >= 0; i--) {

		var asset = optionsIn.groups[i];
		this.activeGroup = asset.key;

		var style = (asset.style ? asset.style : optionsIn.style);


		this.dividedAssets.push({'key': asset.key, field: asset.field, inst: new dividedAsset({
			fullSource: this.fullSource, 
			field: asset.field, 
			style: style,
			visible: this.visible,
			group_id: (optionsIn.group_id ? optionsIn.group_id : null),
		})});
	}
}

dividedAssetManger.prototype.setZindexBy = function(propKey) {

	for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

	//	console.log('this.dividedAssets[i].inst.getAssets()', this.dividedAssets[i].inst.getAssets());

		var assets = this.dividedAssets[i].inst.getAssets();

		for(var key in assets){
			
			var daAssets = assets[key];
		//	console.log('daAssets', daAssets);
			var features = daAssets.sourceClean.getFeatures();

			var count = 0;

			for (var n = features.length - 1; n >= 0; n--) {
				var value = features[n].getProperties()[propKey];
				if(typeof value === 'undefined' || value === null){
					continue;
				}
				count += parseInt(features[n].getProperties()[propKey]);

			}
			
			daAssets.layer.setZIndex(100000000000000 - count);
		}
	}
}

//get assets by group
dividedAssetManger.prototype.getAssets = function() {

	var groupsAssets = {}
	for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

		groupsAssets[this.dividedAssets[i].key] = this.dividedAssets[i].inst.getAssets();
	}

	return groupsAssets;
}

//groupProp - property of the feature which coresponds for the feature group field
dividedAssetManger.prototype.drawActive = function(activeGroups, groupProp){

		if(typeof groupProp === 'undefined') {

			groupProp = 'Nozare';
		}
		
		var assetsGrouped = this.getAssets();
		

		for(var assetGroup in assetsGrouped) {

			for(var key in assetsGrouped[assetGroup]) {

				if(key == '') {
					continue;
				}
			//	console.log('KEY:', key);
				var assets =  assetsGrouped[assetGroup][key];

				var allFeatures = assets.sourceClean.getFeatures();
			//	console.log('assets.sourceFiltred', assets.sourceFiltred);
				assets.sourceFiltred.clear();

				if(activeGroups.length === 0 || assetGroup !== this.activeGroup) {
					assets.layer.setVisible(false);
				} else {

					assets.layer.setVisible(true);
				}

				var featuresFiltred = [];
				
				for (var i = 0, len = allFeatures.length; i < len; i++){

					var props = allFeatures[i].getProperties();

					var bolAdd = false;

					for(var ig = 0, leng = activeGroups.length; ig < leng; ig++) {
						var group = activeGroups[ig];
						
						if(props[groupProp] === group) {
							bolAdd = true;
						}
					}

					if(bolAdd) {
						featuresFiltred.push(allFeatures[i]);
					}
				}
				
			//	console.log('addFeatures', featuresFiltred);
				assets.sourceFiltred.addFeatures(featuresFiltred);
			}

		}

	}
// draws active features by validating against external function
dividedAssetManger.prototype.drawActiveValidate = function(validFunction){

		
		var assetsGrouped = this.getAssets();

		for(var assetGroup in assetsGrouped) {

			for(var key in assetsGrouped[assetGroup]) {

				if(key == '') {
					continue;
				}
			//	console.log('KEY:', key);
				var assets =  assetsGrouped[assetGroup][key];

				var allFeatures = assets.sourceClean.getFeatures();
			//	console.log('assets.sourceFiltred', assets.sourceFiltred);
				assets.sourceFiltred.clear();

			/*	if(activeGroups.length === 0 || assetGroup !== this.activeGroup) {
					assets.layer.setVisible(false);
				} else {

					assets.layer.setVisible(true);
				}*/

				var featuresFiltred = [];
				
				for (var i = 0, len = allFeatures.length; i < len; i++){

					var props = allFeatures[i].getProperties();

					if(validFunction(props, allFeatures[i])) {
						featuresFiltred.push(allFeatures[i]);
					}
				}
				
			//	console.log('dividedAssetManger ddFeatures', featuresFiltred);
				assets.sourceFiltred.addFeatures(featuresFiltred);
			}

		}

	}

dividedAssetManger.prototype.verfyClusering = function(assetName, type) {

	switch(this.noneGroup){
		case 'NONE':

			if((type === 'full' || type === 'regular') && assetName === 'NONE'){
				return false;
			} else {
				return true;
			}

		break;
		case 'MIN':
			if(type === 'full' && assetName === 'NONE'){
				return false;
			} else {
				return true;
			}
		break;
	}
}

dividedAssetManger.prototype.setFullCluster = function() {

	for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

		var daAssets = this.dividedAssets[i].inst.getAssets();

		for(var assetName in daAssets) {

			if(!this.verfyClusering(assetName, 'full')){
				continue;
			}

			daAssets[assetName].layer.setSource(daAssets[assetName].sourceClusterFull);
		}

	}
}

dividedAssetManger.prototype.setRegularCluster = function() {

	for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

		var daAssets = this.dividedAssets[i].inst.getAssets();

		for(var assetName in daAssets) {

			if(!this.verfyClusering(assetName, 'regular')){
				continue;
			}

			daAssets[assetName].layer.setSource(daAssets[assetName].source);
		}
	}
}

dividedAssetManger.prototype.setRegularClusterMin = function() {

	for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

		var daAssets = this.dividedAssets[i].inst.getAssets();

		for(var assetName in daAssets) {

			if(!this.verfyClusering(assetName, 'regular')){
				continue;
			}

			daAssets[assetName].layer.setSource(daAssets[assetName].sourceCluserMin);
		}
	}
}

dividedAssetManger.prototype.setNoCluster = function() {

	for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

		var daAssets = this.dividedAssets[i].inst.getAssets();

		for(var assetName in daAssets) {

			daAssets[assetName].layer.setSource(daAssets[assetName].sourceClean);
		}
	}
}

dividedAssetManger.prototype.getLayers = function() {

	var allLayers = [];

	for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

		allLayers = allLayers.concat(this.dividedAssets[i].inst.getLayers());
	}

	return allLayers;
}

dividedAssetManger.prototype.getActiveGroup = function() {

	return this.activeGroup;
}

//Loops all features, note that all sources have the same features referenced (??), so features are taken from 1st group
dividedAssetManger.prototype.loopAllFeatures = function(callback) {

	return this.dividedAssets[0].inst.loopAllFeatures(callback);
}

dividedAssetManger.prototype.setVisibleGroup = function(strKey, bolActive) {

	if(typeof bolActive === 'undefined') {
		bolActive = true;
	}

	for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

		if(this.dividedAssets[i].key === strKey) {

			this.activeGroup = strKey;
			
			if(bolActive) {
				console.log('activate ', strKey);
				this.dividedAssets[i].inst.setVisible(true);
			}
			
		} else {
			this.dividedAssets[i].inst.setVisible(false);
		}
	}
}

dividedAssetManger.prototype.generate = function(data){

	for (var i = this.dividedAssets.length - 1; i >= 0; i--) {
		
		this.dividedAssets[i].inst.generate(data);
	}


	if(this.noneGroup === 'NONE') {

		for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

			var daAssets = this.dividedAssets[i].inst.getAssets();

			for(var assetName in daAssets) {

				if(assetName === 'NONE') {

					daAssets[assetName].layer.setSource(daAssets[assetName].sourceClean);
				}
				
			}
		}
	}

	if(this.noneGroup === 'MIN') {

		for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

			var daAssets = this.dividedAssets[i].inst.getAssets();

			for(var assetName in daAssets) {

				if(assetName === 'NONE') {

					daAssets[assetName].layer.setSource(daAssets[assetName].source);
				}
				
			}
		}
	}
}

dividedAssetManger.prototype.setVisible = function(bol) {

	for (var i = this.dividedAssets.length - 1; i >= 0; i--) {

		if(this.activeGroup === this.dividedAssets[i].key) {

			this.dividedAssets[i].inst.setVisible(bol);
		} else {
			this.dividedAssets[i].inst.setVisible(false);
		}
		
	}

	return this;
}

module.exports = dividedAssetManger;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/dividedAsset/dividedAssetManager.js